import { Route, Routes, useParams } from "react-router";

import { PollingIntervalGroups } from "apollo/constants";
import usePolledQuery from "apollo/usePolledQuery";
import NotFoundPage from "components/error/NotFoundPage";
import PageLoading from "components/loading/PageLoading";
import useErrorHandle from "hooks/useErrorHandle";
import useAacFlags from "hooks/useAacFlags";

import { GET_ROLE } from "./gql";
import RolePageLayout from "./PageLayout";
import RolePermissions from "./Permissions";
import RoleUsedBy from "./UsedBy";

type RoleProps = {
  readOnly?: boolean;
};

const Role = ({ readOnly }: RoleProps) => {
  const { nonRootAdminRoleBindings } = useAacFlags();
  const { roleId } = useParams<{ roleId: string }>();

  const { data, loading, error } = usePolledQuery(GET_ROLE, {
    variables: {
      id: roleId!,
    },
    skip: !roleId,
    pollingGroup: PollingIntervalGroups.Default,
  });

  const ErrorContent = useErrorHandle(error);

  if (ErrorContent) {
    return ErrorContent;
  }

  if (!data?.role) {
    return loading ? <PageLoading /> : <NotFoundPage />;
  }

  const isReadOnly = readOnly || data.role.isSystem;

  return (
    <RolePageLayout readOnly={isReadOnly} role={data.role}>
      <Routes>
        <Route index element={<RolePermissions readOnly={isReadOnly} role={data.role} />} />
        <Route
          path="used-by"
          element={<RoleUsedBy readOnly={!nonRootAdminRoleBindings} role={data.role} />}
        />
      </Routes>
    </RolePageLayout>
  );
};

export default Role;
